const type = 'advanced'
const path = '/advance/html-python/'
const name = 'index.py'

const conditions = [
  {
    option: 'frontend',
    type: 'different',
    value: 'angular',
  },
]

export { type, path, name, conditions }
